// extracted by mini-css-extract-plugin
export default {"input-box":"SmsNumInput_input-box__RxI6w"};